import React from 'react';

const About: React.FC = () => (
  <div />
);
export default About;
